<template>
  <div>
    <div v-if="active" class="files-viewer">
      <div class="files-viewer__mask" @click="close"></div>
      <div v-if="activeFile" class="files-viewer__container">
        <div class="files-viewer__file">
          <file-viewer class="file-view" :file="activeFile" />
          <div v-if="activeFile.name" class="files-viewer__label">{{ activeFile.name }}</div>
        </div>

        <div class="files-viewer__actions">
          <a class="files-viewer__action files-viewer__download" :href="activeFile.url" target="_blank" download>
            <svg-icon name="upload"></svg-icon>
          </a>
          <button class="files-viewer__action files-viewer__close" @click="close">
            <svg-icon name="times"></svg-icon>
          </button>
        </div>

        <template v-if="files.length > 1">
          <button class="files-viewer__control files-viewer__prev" @click="prev">
            <svg-icon name="arrow-left" size="lg"></svg-icon>
          </button>
          <button class="files-viewer__control files-viewer__next" @click="next">
            <svg-icon name="arrow-right" size="lg"></svg-icon>
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from "@/components/svg-icon";
import FileViewer from "./file-viewer";
import { getFileType } from "@/utils/files";
import { onKeyPress } from "@/utils/input/keyboard";

export default {
  components: { FileViewer, SvgIcon },

  props: [],
  data() {
    return {
      active: false,
      files: [],
      index: 0,
      handlers: [],
    };
  },
  computed: {
    activeFile() {
      const file = this.files[this.index];

      if (!file) return null;

      const { url, name } = file;
      const type = getFileType(url);

      return {
        url,
        name: name || url.split(".").pop(),
        type,
      };
    },
  },
  created() {
    this.handlers = [
      onKeyPress("ArrowLeft", () => {
        this.prev();
      }),
      onKeyPress("ArrowRight", () => {
        this.next();
      }),
      onKeyPress("Escape", () => {
        this.close();
      }),
    ];
  },
  beforeDestroy() {
    this.handlers.forEach((h) => h());
    this.handlers = [];
  },
  methods: {
    open(files) {
      this.files = files;
      this.index = 0;
      this.active = true;
    },
    close() {
      this.active = false;
      this.files = [];
      this.index = 0;
    },
    next() {
      let next = this.index + 1;
      if (next >= this.files.length) next = 0;
      this.index = next;
    },
    prev() {
      let prev = this.index - 1;
      if (prev < 0) prev = this.files.length - 1;
      this.index = prev;
    },
  },
};
</script>

<style lang="scss" scoped>
.files-viewer {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9999;

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1;
    cursor: pointer;
  }

  &__container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    pointer-events: none;
  }

  &__actions {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
  }

  &__action,
  &__control {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: #262626;
    text-decoration: none;
    border: none;
    cursor: pointer;
    pointer-events: all;
  }

  &__action {
    width: 38px;
    height: 38px;
  }

  &__control {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 38px;
    height: 38px;
  }

  &__prev {
    left: 6px;
  }

  &__next {
    right: 6px;
  }

  &__file {
    position: absolute;
    top: 50px;
    left: 50px;
    right: 50px;
    bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .file-view {
    overflow: hidden;
    pointer-events: all;
  }

  &__label {
    color: white;
    text-align: center;
    font-size: 13px;
    margin-top: 12px;
    pointer-events: all;
  }
}
</style>
